import { createStore } from 'zustand';
import { cookieUtil } from '../utils/cookie/cookie';
import { cookieKey } from '@/shared/consts/cookie-key';

interface SearchKeywordsCookie {
  searchKeywords: string[];
  unshift: (searchKeywords: string) => void;
  delete: (index: number) => void;
  deleteAll: () => void;
}

export interface CookieStores {
  searchKeywords: ReturnType<typeof createSearchKeywordStore>;
}

export function createSearchKeywordStore(initSearchKeywords: string) {
  return createStore<SearchKeywordsCookie>((set, get) => {
    const setWithSync: typeof set = (fnOrState) => {
      set(fnOrState);
      cookieUtil.set(cookieKey.searchKeywords, JSON.stringify(get().searchKeywords));
    };

    return {
      searchKeywords: (initSearchKeywords ? JSON.parse(initSearchKeywords) : []) as string[],
      unshift: (keyword) => {
        const { searchKeywords: prevKeywords } = get();

        const hasIdx = prevKeywords.findIndex((prevKeyword) => prevKeyword === keyword);
        if (hasIdx !== -1) {
          setWithSync(() => {
            const copy = [...prevKeywords];
            copy.splice(hasIdx, 1);
            copy.unshift(keyword);

            return { searchKeywords: copy };
          });

          return;
        }

        setWithSync(({ searchKeywords }) => ({ searchKeywords: [keyword, ...searchKeywords] }));
      },
      delete: (index) => {
        setWithSync(({ searchKeywords }) => {
          searchKeywords.splice(index, 1);

          return {
            searchKeywords: [...searchKeywords],
          };
        });
      },
      deleteAll: () => {
        setWithSync({ searchKeywords: [] });
      },
    };
  });
}
